<div class="policy-container">
  <app-header></app-header>

  <section class="hero-section">
    <div class="hero-content">
      <h1 class="hero-title">Terms of Service</h1>
      <p class="hero-subtitle">Last Updated: {{ lastUpdated }}</p>
      <div class="hero-divider"></div>
    </div>
  </section>

  <section class="content-section" #policyContent>
    <div class="content-container">
      <div class="content-layout">
        <aside class="sidebar">
          <nav class="sidebar-nav">
            <h2 class="sidebar-title">Table of Contents</h2>
            <ul class="nav-list">
              <li *ngFor="let section of sections">
                <button
                  (click)="scrollToSection(section.id)"
                  class="nav-link"
                  [class.active]="isActive(section.id)"
                  [attr.aria-current]="isActive(section.id) ? 'true' : null"
                >
                  {{ section.title }}
                </button>
              </li>
            </ul>
          </nav>
        </aside>

        <main class="main-content">
          <div class="articles-container">
            <article
              *ngFor="let section of sections; trackBy: trackBySection"
              [id]="section.id"
              class="content-article"
              [attr.aria-labelledby]="section.id + '-title'"
            >
              <h2 class="article-title" [id]="section.id + '-title'">
                {{ section.title }}
              </h2>
              <div class="article-content" [innerHTML]="section.content"></div>
            </article>
          </div>
        </main>
      </div>
    </div>
  </section>

  <app-footer></app-footer>
</div>
